import "./campaign-page.scss";

const footerElement = document.querySelector<HTMLDivElement>('.footer__language');
if (footerElement) {
    footerElement.style.display = 'none';
}
